import keycloakInstance from "@/initKeycloak";
import axios from "axios";
import { diagnosticEventLog } from "@/shared/services/diagnostic/DiagnosticEventLog";
import { attachRetryOn401 } from "@/shared/api/interceptors/retryOn401";

export const baseUrl = import.meta.env.VITE_HEADLINES_BASE_URL;

export const client = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

client.interceptors.request.use(async (config) => {
  if (keycloakInstance && keycloakInstance.authenticated) {
    try {
      await keycloakInstance.updateToken(30); // Refresh if expiring within 30s
      config.headers.Authorization = `Bearer ${keycloakInstance.token}`;
    } catch (error) {
      console.error("Token refresh error in interceptor:", error);
    }
  }
  return config;
});

client.interceptors.response.use(undefined, (error) => {
  const url = error.config?.url ?? "unknown";
  const path = url.split("?")[0]; // strip query params
  diagnosticEventLog.record("headlines:http", "error", "http-error", {
    status: error.response?.status,
    method: error.config?.method?.toUpperCase(),
    path,
    message: error.message,
  });
  return Promise.reject(error);
});

attachRetryOn401(client);

export { useHeadlinesCRUD } from "./useHeadlinesCRUD";
export { useHeadlines } from "./useHeadlines";
export { useDelayedHeadlines } from "./useDelayedHeadlines";
export { useHeadlineById } from "./useHeadlineById";
export { useHeadlinesByTag } from "./useHeadlinesByTag";
export { useSearchHeadlines } from "./useSearchHeadlines";
export { useIsPollingMode } from "./useIsPollingMode";
export type { HeadlineCreateInput, HeadlineUpdateInput } from "./useHeadlinesCRUD";
export * from "./api";
export * from "./types";

// Re-export all tag-related functionality from tags subfolder
export * from "./tags";
